import { render, staticRenderFns } from "./HolidaysPage.vue?vue&type=template&id=08619c1e"
import script from "./HolidaysPage.vue?vue&type=script&lang=js"
export * from "./HolidaysPage.vue?vue&type=script&lang=js"
import style0 from "./HolidaysPage.vue?vue&type=style&index=0&id=08619c1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports